<template>
  <setting-auto-liked-search-form
    v-if="showSearchForm"
    :base-condition-data="searchData"
    :contract-id="contractId"
    @submit="updateAutoLikedSearchCondition"
  />
</template>

<script>
import Indicator from '@/lib/indicator'
import { SearchDataModel } from '@/model/searchDataModel'
import SettingAutoLikedSearchForm from '@/components/organisms/SettingAutoLikedSearchForm'
import { mapGetters } from 'vuex'

export default {
  components: {
    SettingAutoLikedSearchForm
  },
  data () {
    return {
      searchData: new SearchDataModel(),
      showSearchForm: false
    }
  },
  computed: {
    ...mapGetters('contracts', {
      publishedContracts: 'publishedContracts'
    }),
    contractId () {
      return this.publishedContracts[0].id
    }
  },
  created () {
    Indicator.emitShow()
    this.$http.secured.get(`/scout/message/send/auto_liked_settings/search_conditions/${this.$route.params.conditionId}`)
      .then(response => {
        this.$set(this, 'searchData', new SearchDataModel(this.responseMappingSearchCondition(response.data)))
        if (!this.searchData.parameter.age.minimum) {
          this.$set(this.searchData.parameter.age, 'minimum', 18)
        }
        if (!this.searchData.parameter.age.maximum) {
          this.$set(this.searchData.parameter.age, 'maximum', 65)
        }
      }).finally(() => {
        Indicator.emitHide()
        // APIが完了してから子コンポーネントの描画を行う
        this.$set(this, 'showSearchForm', true)
      })
  },
  methods: {
    responseMappingSearchCondition (data) {
      const condition = JSON.parse(data.condition)
      const parameter = data.parameter
      if (parameter.occupations.desired) {
        // 描画用にオブジェクトの配列に変換する
        parameter.occupations.desired = parameter.occupations.desired.map(x => { return { id: x } })
      }

      return {
        id: data.id,
        parameter: parameter,
        condition: condition
      }
    },
    updateAutoLikedSearchCondition (apiConditionParameter) {
      this.$http.secured.put(
        `/scout/message/send/auto_liked_settings/jobs/${this.$route.params.jobId}/search_conditions/${this.$route.params.conditionId}`,
        { ...apiConditionParameter }
      ).then(() => {
        this.goResults()
      }).catch(error => { throw error })
    },
    goResults () {
      this.$router.push('/settings/auto_liked')
    }
  }
}
</script>
